export default "__VITE_ASSET__CVF85u9g__"